import Api from "..";

const normalizarListaUsuarios = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.usuarios)) return payload.usuarios;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.data?.usuarios)) return payload.data.usuarios;
    return [];
};

const getUsuarios = async () => {
    try {
        const response = await Api.get("usuario/listarUsuarios");
        return normalizarListaUsuarios(response.data);
    } catch (error) {
        const mensagem =
            error.response?.data?.erro ||
            error.response?.data?.message ||
            error.message ||
            "Erro ao buscar usuários";
        throw new Error(`Erro ao buscar usuários: ${mensagem}`);
    }
};

const getUsuarioById = async (id) => {
    try {
        const response = await Api.get(`/usuario/buscarUsuarioPorId?id=${id}`);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao buscar usuário com ID ${id}: ${error.message}`);
    }
}

const createUsuario = async (usuarioData) => {
    try {
        const response = await Api.post("/usuario/criarUsuario", usuarioData);
        return response.data;
    } catch (error) {
        throw error;
    }
}

const updateUsuario = async (id, usuarioData) => {
    try {
        const response = await Api.patch(`/usuario/atualizarUsuario?id=${id}`, usuarioData);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao atualizar usuário com ID ${id}: ${error.message}`);
    }
}

const adminResetPassword = async (usuarioId) => {
  try {
    const response = await Api.post("/usuario/admin-reset-senha", { usuarioId });
    return response.data;
  } catch (error) {
    console.error('Erro no adminResetPassword:', error.response?.data || error.message);
    throw error.response?.data || new Error('Erro ao resetar senha');
  }
};

// ADICIONE ESTA FUNÇÃO
const adminResetAllPasswords = async () => {
  try {
    const response = await Api.post("/usuario/admin-reset-global");
    return response.data;
  } catch (error) {
    console.error('Erro no adminResetAllPasswords:', error.response?.data || error.message);
    throw error.response?.data || new Error('Erro no reset global');
  }
};

const searchUsuarios = async (termo, opcoes = {}) => {
  if (!termo) return []; // Não faz busca se o termo for vazio
  try {
    const params = new URLSearchParams({ q: termo });
    // Por padrão o endpoint não lista admins; o envio de notificação pede incluirAdmin
    if (opcoes.incluirAdmin) params.append('incluirAdmin', 'true');
    const response = await Api.get(`/usuario/buscar-por-termo?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar usuários:', error.response?.data || error.message);
    throw error.response?.data || new Error('Erro ao buscar usuários');
  }
};

// Busca paginada de usuários (para o modal de seleção). filtroPerfil: 'publicadores' | 'coordenadores' | undefined
const buscarSimples = async ({ search = '', page = 1, limit = 8, filtroPerfil } = {}) => {
  try {
    const params = { search, page, limit };
    if (filtroPerfil) params.filtroPerfil = filtroPerfil;
    const response = await Api.get('usuario/buscar-simples', { params });
    const data = response.data || {};
    return {
      itens: Array.isArray(data.usuarios) ? data.usuarios : [],
      total: typeof data.total === 'number' ? data.total : (Array.isArray(data.usuarios) ? data.usuarios.length : 0),
    };
  } catch (error) {
    console.error('Erro ao buscar usuários (simples):', error.response?.data || error.message);
    return { itens: [], total: 0 };
  }
};

// Publicadores com disponibilidade em um ou mais pontos (envio de notificação escopado)
const listarDisponiveisPorPonto = async (pontoIds = []) => {
  const ids = (Array.isArray(pontoIds) ? pontoIds : [pontoIds]).filter(Boolean);
  if (ids.length === 0) return [];
  try {
    const response = await Api.get(`/usuario/disponiveis-por-ponto?pontoIds=${ids.join(',')}`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error('Erro ao buscar publicadores disponíveis:', error.response?.data || error.message);
    return [];
  }
};

const listar = async (params = {}) => {
    try {
        const { busca = '', page = 1, limit = 10 } = params;
        const query = busca ? `?busca=${encodeURIComponent(busca)}&page=${page}&limit=${limit}` : `?page=${page}&limit=${limit}`;
        const response = await Api.get(`usuario/listarUsuarios${query}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || { erro: 'Erro ao buscar usuários' };
    }
};

const atualizar = async (id, dados) => {
    try {
        const response = await Api.patch(`/usuario/atualizarUsuario?id=${id}`, dados);
        return response.data;
    } catch (error) {
        throw error.response?.data || { erro: 'Erro ao atualizar usuário' };
    }
};

export default {
    getUsuarios,
    getUsuarioById,
    createUsuario,
    updateUsuario,
    adminResetPassword,      
    adminResetAllPasswords,
    searchUsuarios,
    buscarSimples,
    listarDisponiveisPorPonto,
    listar,
    atualizar
};